import { Field, Select } from "@/components/FormField";

const WATER_OPTIONS = ["Available", "Limited", "Not Available"];

export default function FarmPlantationFields({ extra, updExtra }) {
  return (
    <>
      <div className="text-sm font-semibold text-[var(--yp-primary)] sm:col-span-2 -mb-2">Farm / Plantation Information</div>
      <Select id="sr-farm-water" label="Water availability" value={extra.water || ""} onChange={(v) => updExtra("water", v)} options={WATER_OPTIONS} />
      <Field id="sr-farm-crop" label="Existing crop / plantation" value={extra.existing_crop || ""} onChange={(v) => updExtra("existing_crop", v)} />
      <Field id="sr-farm-species" label="Species / crop interest" value={extra.species || ""} onChange={(v) => updExtra("species", v)} placeholder="Agarwood, bamboo, fruit plants..." />
      <Field id="sr-farm-qty" label="Approx. plant quantity" type="number" value={extra.plant_qty || ""} onChange={(v) => updExtra("plant_qty", v)} />
    </>
  );
}
